"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentProvider = void 0;
var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["NA"] = "NA";
    PaymentProvider["FakePaymentMethod"] = "fakePaymentMethod";
    PaymentProvider["Stripe"] = "com.stripe";
    PaymentProvider["StripeGateway"] = "28a3d9c7-24d7-49c8-a2bd-c1feddb257a5";
    PaymentProvider["Square"] = "com.square";
    PaymentProvider["PayPal"] = "payPal";
    PaymentProvider["MercadoPago"] = "mercadoPago";
    PaymentProvider["PagSeguro"] = "pagSeguro";
    PaymentProvider["Worldpay"] = "com.worldpay.smb";
    PaymentProvider["Fatzebra"] = "au.com.fatzebra";
    PaymentProvider["Eway"] = "com.eway";
    PaymentProvider["Braintreegateway"] = "com.braintreegateway";
    PaymentProvider["TwoCheckout"] = "com.2checkout";
    PaymentProvider["Wirecard"] = "com.wirecard";
    PaymentProvider["LeumiCard"] = "il.co.shva.zooz";
    PaymentProvider["CitrusPay"] = "com.citruspay";
    PaymentProvider["PayUTurkey"] = "tr.payu";
    PaymentProvider["AuthorizeNET"] = "net.authorize";
    PaymentProvider["Dlocal"] = "com.dlocal";
    PaymentProvider["WixPayBR"] = "com.wix.wixpay";
    PaymentProvider["WixPayUS"] = "com.wix.wixpay.us";
    PaymentProvider["CreditGuard"] = "il.co.creditguard";
    PaymentProvider["DengiOnline"] = "com.dengionline";
    PaymentProvider["PaymentExpress"] = "com.paymentexpress";
    PaymentProvider["PagueloFacil"] = "com.paguelofacil";
    PaymentProvider["SumUp"] = "sumUp";
    PaymentProvider["Isracard"] = "il.co.isracard";
    PaymentProvider["Epsilon"] = "jp.epsilon";
    PaymentProvider["Interkassa"] = "569a9662-9bf9-49b5-a5dd-5f1528c6100d";
    PaymentProvider["UniPay"] = "c7ed6c23-dad5-47a2-be03-b7808f6817d7";
    PaymentProvider["BitPay"] = "594e74f7-5543-42f4-bd30-efbee3ea51b1";
    PaymentProvider["Afterpay"] = "385bfbe3-01cb-4544-86aa-41f3828b50ad";
    PaymentProvider["Clearpay"] = "f7da7147-483e-418d-9e7c-b2aa28212729";
    PaymentProvider["Lyra"] = "c9a1097e-ae74-4752-af9c-1d742cca6589";
    PaymentProvider["Laybuy"] = "70153d33-fdf7-425d-8eb3-bdb18475cd12";
    PaymentProvider["Affirm"] = "fa75e2c4-1ba3-4cb1-91e0-f28e8c29c629";
    PaymentProvider["Sezzle"] = "f420f6d2-f895-439e-b28e-b9ba90157013";
    PaymentProvider["Atome"] = "ba2678da-3e4f-4da9-910c-17fd64316770";
})(PaymentProvider = exports.PaymentProvider || (exports.PaymentProvider = {}));
//# sourceMappingURL=PaymentProvider.js.map